var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2.75C1.5 2.05933 2.06 1.5 2.75 1.5H6.25C6.94067 1.5 7.5 2.06 7.5 2.75V11.5C7.5 12.2956 7.18393 13.0587 6.62132 13.6213C6.05871 14.1839 5.29565 14.5 4.5 14.5C3.70435 14.5 2.94129 14.1839 2.37868 13.6213C1.81607 13.0587 1.5 12.2956 1.5 11.5V2.75ZM4.5 12.25C4.69891 12.25 4.88968 12.171 5.03033 12.0303C5.17098 11.8897 5.25 11.6989 5.25 11.5C5.25 11.3011 5.17098 11.1103 5.03033 10.9697C4.88968 10.829 4.69891 10.75 4.5 10.75C4.30109 10.75 4.11032 10.829 3.96967 10.9697C3.82902 11.1103 3.75 11.3011 3.75 11.5C3.75 11.6989 3.82902 11.8897 3.96967 12.0303C4.11032 12.171 4.30109 12.25 4.5 12.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14648 14.4988H13.2505C13.9412 14.4988 14.5005 13.9388 14.5005 13.2488V9.74879C14.5005 9.05812 13.9405 8.49879 13.2505 8.49879H13.1572L7.32915 14.3275C7.26915 14.3868 7.20915 14.4441 7.14648 14.4988ZM8.49248 11.7488L12.8085 7.43279C13.0428 7.19838 13.1744 6.88053 13.1744 6.54912C13.1744 6.2177 13.0428 5.89985 12.8085 5.66545L10.3338 3.19012C10.0994 2.95583 9.78157 2.82422 9.45015 2.82422C9.11874 2.82422 8.80089 2.95583 8.56648 3.19012L8.49982 3.25612V11.4988C8.49982 11.5828 8.49782 11.6661 8.49315 11.7488H8.49248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.8a9b7d8cfe54c077705002241e77bec7.svg";
export { ForwardRef as ReactComponent };